import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Particles from "../components/Particles";

export default function NotFound() {
  useEffect(() => {
    document.title = "404 — JOBLSX";
  }, []);
  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden px-6">
      <div className="orb h-[400px] w-[400px] bg-blue-600/20 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />
      <Particles count={24} />
      <div className="relative z-10 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="font-display text-[7rem] font-semibold leading-none tracking-tighter sm:text-[11rem]"
        >
          4<span className="text-blue-500">0</span>4
        </motion.h1>
        <p className="mt-4 text-lg text-slate-400">This page drifted off the strategy map.</p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mx-auto mt-8 inline-flex items-center gap-2 rounded-full bg-blue-600 px-8 py-4 font-medium text-white shadow-[0_0_24px_rgba(37,99,235,0.4)] transition-all duration-300 hover:bg-blue-700 hover:-translate-y-1"
        >
          <ArrowLeft className="h-4 w-4" /> Back Home
        </Link>
      </div>
    </section>
  );
}
